import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { KnowledgeService } from 'src/app/services/knowledge/knowledge.service'
import {
  LOAD_KNOWLEDGE_SUMMARY_DETAILS,
  LOAD_KNOWLEDGE_SUMMARY_DETAILS_SUCCESS,
  PUBLISH_KNOWLEDGE_ARTICLE_ACTION,
  UPDATE_KNOWLEDGE_ARTICLE_ACTION,
  UPDATE_KNOWLEDGE_ARTICLE_SUCCESS_ACTION,
  load_knowledge_quick_option_details,
  load_knowledge_quick_option_details_success,
  save_knowledge_action,
  save_knowledge_success_action,
  search_knowledge_action,
  search_knowledge_success_action,
  view_knowledge_action,
  view_knowledge_success_action
} from '../action/knowledge.action'
import { catchError, map, mergeMap, of } from 'rxjs'
import { route_to_action, show_error_action, show_success_msg_action } from '../action/common/common.action'
import { GlobalConstants } from 'src/app/constants/global-constants'

@Injectable()
export class KnowledgeEffects {
  constructor(private readonly actions$: Actions, private readonly knowledgeService: KnowledgeService) {}

  save_knowledge_action$ = createEffect(() =>
    this.actions$.pipe(
      ofType(save_knowledge_action),
      mergeMap(({ knowledge, files }) =>
        this.knowledgeService.callSaveApi(knowledge, files).pipe(
          mergeMap(response => [
            save_knowledge_success_action({ knowledge: response }),
            route_to_action({
              routeTo: `/${GlobalConstants.ROUTING.KNOWLEDGE_HUB}/${response.id}`
            })
          ]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  update_knowledge_action$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UPDATE_KNOWLEDGE_ARTICLE_ACTION),
      mergeMap(({ knowledgeArticle, files, id, routeTo }) =>
        this.knowledgeService.callUpdateApi(knowledgeArticle, id, files).pipe(
          mergeMap(response => [UPDATE_KNOWLEDGE_ARTICLE_SUCCESS_ACTION({ knowledgeArticle: response, routeTo })]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  view_knowledge_action$ = createEffect(() =>
    this.actions$.pipe(
      ofType(view_knowledge_action),
      mergeMap(({ id, includeDocumentLinks }) =>
        this.knowledgeService.callViewApi(id, includeDocumentLinks).pipe(
          mergeMap(response => [view_knowledge_success_action({ knowledge: response })]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  search_knowledge_action$ = createEffect(() =>
    this.actions$.pipe(
      ofType(search_knowledge_action),
      mergeMap(data =>
        this.knowledgeService.invokeKnowledgeSummaryAPI(data.queryParams, data.searchRequestBody).pipe(
          mergeMap(response => [
            search_knowledge_success_action({ knowledge: response }),
            route_to_action({ routeTo: data.routeTo })
          ]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  load_knowledge_summary$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LOAD_KNOWLEDGE_SUMMARY_DETAILS),
      mergeMap(data =>
        this.knowledgeService.invokeKnowledgeSummaryAPI(data.queryParams, data.searchRequestBody).pipe(
          map(knowledgeResponse => LOAD_KNOWLEDGE_SUMMARY_DETAILS_SUCCESS({ knowledge: knowledgeResponse })),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  load_quick_select_option$ = createEffect(() =>
    this.actions$.pipe(
      ofType(load_knowledge_quick_option_details),
      mergeMap(data =>
        this.knowledgeService.invokeKnowledgeSummaryAPI(data.queryParams, data.searchRequestBody).pipe(
          map(knowledgeResponse => load_knowledge_quick_option_details_success({ knowledge: knowledgeResponse })),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  publish_knowledge_action$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PUBLISH_KNOWLEDGE_ARTICLE_ACTION),
      mergeMap(({ id }) =>
        this.knowledgeService.invokePublishKnowledgeSummaryAPI(id).pipe(
          mergeMap(response => [
            show_success_msg_action({ msg: 'Published Successfully' }),
            route_to_action({
              routeTo: `/${GlobalConstants.ROUTING.KNOWLEDGE_HUB}/${GlobalConstants.ROUTING.LIST}`
            })
          ]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )
}
